const { set: _set } = (typeof document === "undefined"
    ? undefined
    : Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value")) ?? { set: () => { } };
export const setInputValueNative = (node, val) => _set?.call(node, val);
export function clearInputValueAndEmitChangeEvent(input) {
    // Setting the value with inputRef.current.value will cause the dispatched event to get ignored
    // React overrides native .value setter on inputs and tracks input values internally https://github.com/facebook/react/blob/21a161fa37dce969c58ae17f67f2856d06514892/packages/react-dom-bindings/src/client/inputValueTracking.js#L129
    // So we get the native setter from input's prototype
    setInputValueNative(input, "");
    input.dispatchEvent(new InputEvent("input", {
        bubbles: true,
        view: window,
        isComposing: false,
        inputType: "deleteContent"
    }));
}
